<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="500" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4.py-3
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          div.d-flex.align-center.justify-center.fill-height
            slot(name="title")
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      slot(name="content")
    v-divider
    v-card-actions.py-3.px-4
      slot(name="actions")
        y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeDialog")
        v-spacer
        y-button(label="Discard" color="danger500" outlined size="sm" @click="discardData")
        y-button(label="Save" size="sm" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    offerId: {
      default: null
    },
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.isLoading = true
      this.$emit('save')
    },
    discardData () {
      this.$emit('discard')
    },
    closeDialog () {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
</style>